import 'core-js/modules/es.promise.js';
import { __awaiter } from '../../_virtual/_tslib.js';

class DataUrlToFile {
  execute(dataUrl, fileName) {
    return __awaiter(this, void 0, void 0, function* () {
      const res = yield fetch(dataUrl);
      const blob = yield res.blob();
      return new File([blob], fileName, {
        type: 'image/png'
      });
    });
  }
}

export { DataUrlToFile };
